export default __webpack_public_path__ + "static/media/swami2.808446dc.png";